import { render, staticRenderFns } from "./ShadowBtn3.vue?vue&type=template&id=2106ec0c&scoped=true"
import script from "./ShadowBtn3.vue?vue&type=script&lang=js"
export * from "./ShadowBtn3.vue?vue&type=script&lang=js"
import style0 from "./ShadowBtn3.vue?vue&type=style&index=0&id=2106ec0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106ec0c",
  null
  
)

export default component.exports